import { Box, Container } from "@mui/material";
import React from "react";
import BgLayout from "../components/Base/BgLayout";
import YoutubeEmbed from "../components/Base/YoutubeEmbed";

export default function VideoLayout() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        position: "relative",
        px: "0px !important",
        mt: "40px",
        //mb: "160px",
      }}
    >
      <BgLayout
        sxProps={{ width: "100%", minHeight: { xs: "420px", sm: "570px" } }}
        sxBox={{ pt: 0 }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            width: "100%",
            height: "100%",
            minHeight: { xs: "420px", sm: "570px" },
          }}
        >
          <YoutubeEmbed embedId={"PVxwzH13KJk"} />
        </Box>
      </BgLayout>
    </Container>
  );
}
